<template>
  <div class="general-script-main">
    <h3>
      <span>{{$t('message.script_data_export') | title}}</span>
      <span class="wiki-link">
        <a :href="$t('message.script_data_import_export_doc_link')" target="_blank">
          WIKI
        </a>
      </span>
    </h3>

    <b-form v-if="exportConfig">
      <b-form-row>
        <div class="col-3">
          <span class="label label-default">
            {{ $t("message.data_import_export_auto_enabled") | title }}
          </span>
        </div>
        <div class="col-2">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="exportConfig.auto_enabled"
              @input="isDirty=true"/>
          </div>
        </div>
      </b-form-row>

      <b-form-row v-if="initConfig && initConfig.guaca == 'configured'">
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_export_sm_data') | title}}</span>
        </div>
        <div class="col-2">
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="exportConfig.export_sm_data"
            :disabled="exportConfig.export_destination.type==''" @input="isDirty=true"/>
          </div>
        </div>
        <div class="col-7">
          {{$t("message.data_import_export_export_sm_data_desc")}}
        </div>
      </b-form-row>

      <b-form-row v-if="autoEnabled">
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_auto_interval_type') | title}}</span>
        </div>
        <div class="col-4">
          <b-form-select v-model="exportConfig.auto_interval_type" :options="exportAutoIntervalTypeOptions"
            class="form-control" disabled/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.auto_enabled && exportConfig.auto_interval_type == 'daily'">
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_daily_at_time') | title}}</span>
        </div>
        <div class="col-2">
          <b-form-input v-model="exportConfig.daily_at_time" placeholder="HH:mm" class="form-control"
            @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.auto_enabled && exportConfig.auto_interval_type == 'every x minutes'">
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_every_x_minutes_begin') | title}}</span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.every_x_minutes" type="range" min="10" max="1200" step="10"
            class="form-control" disabled/>
        </div>
        <div class="col-1">
          {{exportConfig.every_x_minutes}}
        </div>
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_every_x_minutes_end') | title}}</span>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.auto_enabled">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_keep_for_days') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input type="range" min="1" max="60" v-model="exportConfig.keep_for_days" @input="isDirty=true"/>
        </div>
        <div class="col-2">
          {{exportConfig.keep_for_days}} days
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_export_destination') | title}}</span>
        </div>
        <div class="col-4">
          <b-form-select v-model="exportConfig.export_destination.type" :options="exportDestinationOptions"
            class="form-control" @change="onExportDestinationTypeChange" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_encrypt_password') | title}} ({{$t('message.required')}})
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.encrypt_password" :type="encryptPasswordInputType"
            :placeholder="$t('message.none_or_no_change')" @input="isDirty=true"/>
        </div>
        <div class="col-2" v-if="exportConfig.encrypt_password && encryptPasswordInputType == 'password'">
          <svg class='icon icon-eye' @click="encryptPasswordInputType='text'"/>
        </div>
        <div class="col-2" v-if="exportConfig.encrypt_password && encryptPasswordInputType == 'text'">
          <svg class='icon icon-eye-active' @click="encryptPasswordInputType='password'"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_server') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.scp_server" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_server_port') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.scp_server_port" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_directory_path') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.scp_directory_path" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_username') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.scp_username" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_auth_method') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-select v-model="exportConfig.export_destination.scp_auth_method"
          :options="scpAuthTypeOptions" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp' &&
                      exportConfig.export_destination.scp_auth_method == 'password'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_password') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input :type="scpPasswordInputType" v-model="exportConfig.export_destination.scp_password"
            :placeholder="$t('message.none_or_no_change')" @input="isDirty=true"/>
        </div>
        <div class="col-2" v-if="exportConfig.export_destination.scp_password && scpPasswordInputType  == 'password'"
          autocomplete="new-password">
          <svg class='icon icon-eye' @click="scpPasswordInputType='text'" />
        </div>
        <div class="col-2" v-if="exportConfig.export_destination.scp_password && scpPasswordInputType  == 'text'">
          <svg class='icon icon-eye-active' @click="scpPasswordInputType='password'"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'scp' &&
                        exportConfig.export_destination.scp_auth_method == 'private key'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_scp_private_key') | title}}
          </span>
        </div>
        <div class="col-8">
          <b-form-textarea class="form-control" v-model="exportConfig.export_destination.scp_private_key"
            :placeholder="$t('message.none_or_no_change')" rows="20" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_smb_server') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.cifs_smb_server" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_smb_share') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.cifs_smb_share" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_username') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.cifs_username" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">{{$t('message.data_import_export_export_destination_cifs_password') | title}}</span>
        </div>
        <div class="col-4">
          <b-form-input :type="cifsPasswordInputType" v-model="exportConfig.export_destination.cifs_password"
            :placeholder="$t('message.none_or_no_change')" @input="isDirty=true"/>
        </div>
        <div class="col-2" v-if="exportConfig.export_destination.cifs_password && cifsPasswordInputType == 'password'">
          <svg class='icon icon-eye' @click="cifsPasswordInputType='text'"/>
        </div>
        <div class="col-2" v-if="exportConfig.export_destination.cifs_password && cifsPasswordInputType == 'text'">
          <svg class='icon icon-eye-active' @click="cifsPasswordInputType='password'"/>
        </div>
      </b-form-row>

      <b-form-row v-if="exportConfig.export_destination.type == 'cifs'">
        <div class="col-3">
          <span class="label label-default">
            {{$t('message.data_import_export_export_destination_cifs_domain') | title}}
          </span>
        </div>
        <div class="col-4">
          <b-form-input v-model="exportConfig.export_destination.cifs_domain" @input="isDirty=true"/>
        </div>
      </b-form-row>

      <div v-if="formError" class="form-error">{{formError}}</div>

      <b-button variant="primary" type="button"
        class="padmin-button submit-button right" @click="save"
          :disabled="runInProgress || !isDirty">
        <b-spinner v-if="saveInProgress" small type="grow"/>
        {{$t('message.button_save') | title}}
      </b-button>
      <b-button v-if="exportButtonVisible" variant="primary" type="button"
        class="padmin-button submit-button right" @click="exportData" :disabled="exportButtonDisabled">
        <b-spinner v-if="exportInProgress" small type="grow"/>
        <span v-if="exportDestinationSet">{{$t('message.button_export') | title}}</span>
        <span v-else>{{$t('message.button_backup') | title}}</span>
      </b-button>
      <b-button variant="primary" type="button"
        class="padmin-button submit-button right" @click="downloadData" :disabled="downloadButtonDisabled">
        <b-spinner v-if="downloadInProgress" small type="grow"/>
        {{$t('message.button_download') | title}}
      </b-button>

    </b-form>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>

  </div>
</template>

<script>
import { get, post, getBinary, forceFileDownload } from "../http"
import ConsoleOutput from "./ConsoleOutput"
import {validateHostName, validateUsername, validateTime, validatePort, validateDirectoryPath, validatePassword} from "../util"

export default {
  name: "exportConfig",

  components: {
    ConsoleOutput
  },

  data() {
    return {
      exportDestinationOptions:[{value: '', text: this.$t('message.data_import_export_export_destination_none')},
                                {value: 'scp', text: this.$t('message.data_import_export_export_destination_scp')},
                                {value: 'cifs', text: this.$t('message.data_import_export_export_destination_cifs')}],
      exportConfig: null,
      initConfig: null,
      result: null,
      output: "",
      formError: '',
      saveInProgress: false,
      exportInProgress: false,
      downloadInProgress: false,
      encryptPasswordInputType: 'password',
      scpPasswordInputType: 'password',
      cifsPasswordInputType: 'password',
      isDirty: false,
      scpAuthTypeOptions: [{value: 'password', text: this.$t('message.data_import_export_export_destination_scp_password')},
                           {value: 'private key', text: this.$t('message.data_import_export_export_destination_scp_private_key')}],
      exportAutoIntervalTypeOptions: [{value: 'daily', text: this.$t('message.data_import_export_auto_interval_type_daily')},
                                      {value: 'every x minutes', text: this.$t('message.data_import_export_auto_interval_type_every_x_minutes')}]
    }
  },

  mounted() {
    this.load()
    this.loadInitConfig()
  },

  computed: {
    runInProgress() {
      return this.saveInProgress || this.exportInProgress || this.downloadInProgress
    },

    exportButtonDisabled() {
      return this.saveInProgress || this.exportInProgress || this.downloadInProgress || this.isDirty
    },

    downloadButtonDisabled() {
      return this.saveInProgress || this.exportInProgress || this.downloadInProgress || this.isDirty
    },

    exportButtonVisible() {
      return this.exportConfig
    },

    autoEnabled() {
      return this.exportConfig.auto_enabled
    },

    exportDestinationSet() {
      return this.exportConfig && this.exportConfig.export_destination &&
        this.exportConfig.export_destination.type != '' && this.exportConfig.export_destination.type != 'none'
    }
  },

  methods: {
    getDataUrl() {
      return ('/scripts/data/export')
    },

    onExportDestinationTypeChange(value) {
      if(!value || value.length == 0) {
        this.exportConfig.export_sm_data = false
      }
    },

    loadInitConfig() {
      get("/init").then(
        resp => {
          this.initConfig = resp.data

        },
        err => {
          console.log("err", err);
        }
      )
    },

    load() {
      get(this.getDataUrl()).then(
        resp => {
          this.exportConfig = resp.data.params.auto_backup.value
          if (this.exportConfig) {
            if (!this.exportConfig.auto_interval_type) {
              this.exportConfig.auto_interval_type = 'daily'
            }
            if (!this.exportConfig.daily_at_time && this.exportConfig.daily_at_hour) {
              this.exportConfig.daily_at_time = this.exportConfig.daily_at_hour + ':00'
            }
            if (!this.exportConfig.every_x_minutes) {
              this.exportConfig.every_x_minutes = '120'
            }
            if (!this.exportConfig.keep_for_days) {
              this.exportConfig.keep_for_days = '30'
            }
            if (!this.exportConfig.export_sm_data) {
              this.exportConfig.export_sm_data = false
            }
            if (this.exportConfig.auto_enabled == undefined) {
              this.exportConfig.auto_enabled = this.exportConfig.enabled
            }
            if (this.exportConfig.export_destination) {
              if (this.exportConfig.export_destination.scp_auth_method == undefined) {
                this.$set(this.exportConfig.export_destination, 'scp_auth_method', 'password')
              }
            } else {
              this.exportConfig.export_destination = {
                  'type': '',
                  'scp_server': '',
                  'scp_username': '',
                  'scp_auth_method': 'password',
                  'scp_password': '',
                  'scp_private_key': '',
                  'scp_directory_path': ''
              }
            }

          } else {
            this.exportConfig = {
              'enabled': false,
              'auto_interval_type': 'daily',
              'daily_at_hour': '4',
              'every_x_minutes': '120',
              'encrypt_password': '',
              'export_sm_data': false,
              'export_destination': {
                  'type': '',
                  'scp_server': '',
                  'scp_username': '',
                  'scp_auth_method': 'password',
                  'scp_password': '',
                  'scp_private_key': '',
                  'scp_directory_path': ''
              }
            }
          }
        },
        err => {
          console.log('err', err)
        })
    },

    save() {
      this.result = null
      this.testResult = null
      this.output = ''
      this.formError = ''

      if (this.exportConfig.export_destination.type == 'scp') {
        if (!validateHostName(this.exportConfig.export_destination.scp_server)) {
          this.formError = this.$t('message.error_invalid_servername')
          return
        }
        if (!validateUsername(this.exportConfig.export_destination.scp_username)) {
          this.formError = this.$t('message.error_invalid_username')
          return
        }
        if (!validatePort(this.exportConfig.export_destination.scp_server_port)) {
          this.formError = this.$t('message.error_invalid_port')
        }
        if (!validateDirectoryPath(this.exportConfig.export_destination.scp_directory_path)) {
          this.formError = this.$t('message.error_invalid_directory_path')
        }
      }
      else if (this.exportConfig.export_destination.type == 'cifs') {
        if (!validateHostName(this.exportConfig.export_destination.cifs_smb_server)) {
          this.formError = this.$t('message.error_invalid_servername')
          return
        }
        if (!validateUsername(this.exportConfig.export_destination.cifs_username)) {
          this.formError = this.$t('message.error_invalid_username')
          return
        }
        if (!validateHostName(this.exportConfig.export_destination.cifs_domain)) {
          this.formError = this.$t('message.error_invalid_domainname')
          return
        }
      }

      if (!validateTime(this.exportConfig.daily_at_time)) {
        this.formError = this.$t('message.error_invalid_time')
        return
      }

      if (this.exportConfig.encrypt_password) {
        let weakPasswdError = validatePassword(this.exportConfig.encrypt_password)
        if (weakPasswdError) {
          this.formError = this.$t('message.error_password_weak') + ': '
            + this.$t('message.error_password_' + weakPasswdError) + '!'
          return
        }
      }

      this.saveInProgress = true
      post(this.getDataUrl(), {'auto_backup': this.exportConfig}, { "Content-Type": "application/json" }).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.saveInProgress = false
          if (this.result) {
            this.isDirty = false
            this.$root.$emit("bv::show::modal", "padmin-restart-modal-id")
          }
        },
        err => {
          console.log('err', err);
          this.saveInProgress = false
          this.result = false
        }
      )
    },

    exportData() {
      this.exportInProgress = true
      this.result = null
      this.output = ''
      this.formError = ''
      post('/export_data').then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.formError = resp.data.error
          this.exportInProgress = false
        },
        err => {
          console.log('err', err);
          this.exportInProgress = false
          this.result = false
          this.output = err
        }
      )
    },

    downloadData() {
      this.downloadInProgress = true
      this.result = null
      this.output = ''
      post('/download_data').then(
        resp => {
          this.result = resp.data.result
          this.formError = resp.data.error
          this.output = resp.data.output

          if (resp.data.download_links) {
            for(let downloadLink of resp.data.download_links) {
              getBinary(downloadLink, this.onDownloadProgress).then(
                resp => {
                  let fileName = downloadLink.split('/').slice(-1).pop()
                  forceFileDownload(resp.data, fileName)
                },
                err => {
                  console.log('err', err)
                  this.result = false
                  this.output += '\nHTTP ERROR:' + err.response.status + ' ' + err.response.statusText
              })
            }
          }
          this.downloadInProgress = false
        },
        err => {
          console.log('err', err);
          this.downloadInProgress = false
          this.result = false
          this.output = err
        }
      )
    }
  }
}
</script>
